const hslToRgb = (hue, saturation, lightness) => {
    saturation /= 100;
    lightness /= 100;

    const c = (1 - Math.abs(2 * lightness - 1)) * saturation;
    const x = c * (1 - Math.abs((hue / 60) % 2 - 1));
    const m = lightness - c / 2;
    let r = 0, g = 0, b = 0;

    if (0 <= hue && hue < 60) {
        r = c;
        g = x;
        b = 0;
    } else if (60 <= hue && hue < 120) {
        r = x;
        g = c;
        b = 0;
    } else if (120 <= hue && hue < 180) {
        r = 0;
        g = c;
        b = x;
    } else if (180 <= hue && hue < 240) {
        r = 0;
        g = x;
        b = c;
    } else if (240 <= hue && hue < 300) {
        r = x;
        g = 0;
        b = c;
    } else if (300 <= hue && hue < 360) {
        r = c;
        g = 0;
        b = x;
    }

    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    return {r, g, b};
};

const calculateLuminance = ({r, g, b}) => {
    const a = [r, g, b].map((v) => {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

export const getContrastingColor = (hue, saturation = 100, lightness = 40) => {
    const rgb = hslToRgb(hue, saturation, lightness);
    const luminance = calculateLuminance(rgb);
    return luminance > 0.179 ? 'black' : 'white';
};

export const getAvatarColorSx = (hue) => {
    if (typeof hue !== 'number' || !Number.isFinite(hue)) {
        return {};
    }
    return {
        backgroundColor: `hsl(${hue},100%,40%)`,
        color: getContrastingColor(hue),
    };
};
